module.exports = __webpack_public_path__ + "static/media/icn-ledger.32c82ff3.svg";